import React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

type MessageLabelProp = {
	name: string;
	petition: {
		href: string;
		title: string;
	};
};

export const MessageLabel: React.FC<MessageLabelProp> = ({ name, petition: { href, title } }) => {
	return (
		<Link
			className="relative mt-2 w-full cursor-default [&>span]:no-underline"
			data-qa="supporter-voices-message-label"
			href={href}
		>
			<Text size="small" className="text-typography-strong inline w-full" as="span">
				<Translate value="corgi.topic_page.supporter_voices.content_title" replacements={{ name }} />
			</Text>{' '}
			<Text
				data-qa={`Topics supporter section link to ${title}`}
				size="small"
				className="inline cursor-pointer underline"
				as="span"
			>
				{title}
			</Text>
		</Link>
	);
};
